import React, {useState} from 'react';
import styled, {useTheme} from "styled-components";
import {useHistory} from "react-router-dom";
import {threedigits} from "../../function";
import CustomClanTags from "./CustomClanTags";
import CustomClanFavoriteButton from "./CustomClanFavoriteButton";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`;
const CustomClanCardTable = ({list}) => {
    return (
        <Wrapper>
            {list.map((data, index) => {
                return (
                    <CustomClanCard key={data.server_name + data.p_num} data={data}/>
                )
            })}
        </Wrapper>
    );
};


const CardWrapper = styled.div`
  cursor: pointer;
  position: relative;
  width: 344px;
  height: 208px;
  overflow: hidden;
`;
const Gradient = styled.div`
  position: absolute;
  width: 344px;
  height: 208px;
  background: linear-gradient(180deg, rgba(27, 30, 31, 0) 18.75%, rgba(27, 30, 31, 0.379549) 44.71%, rgba(27, 30, 31, 0.8) 68.4%, #1B1E1F 100%);
  border-radius: 7px;
  z-index: 1;
`;
const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.background};
  border-radius: 8px;
  overflow: hidden;

`;
const CustomCardTitle = styled.div`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  vertical-align: middle;
  max-width: 328px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  z-index: 1;
  margin-bottom: 8px;
  color: #fff;
`;
const CustomCardInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
`;
const CustomCardTag = styled.div`
  white-space: nowrap;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  height: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 10px;
`;
const CustomCardTagBox = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 250px;

`;

const CustomCardPlayerBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CustomCardPlayerImgBox = styled.div`

`;

const CustomCardPlayerCountBox = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #fff;
`;

const AbsoluteBackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  img {
    object-fit: cover;
  }
`;

const BackgroundContentWrapper = styled.div`
  z-index: 1;
  padding: 16px 16px;
`;
const FavoriteAbsolute = styled.div`
  left: 2px;
  top: 4px;
  z-index: 9999;
  position: absolute;
`;
// const filtered = list.filter((data) => data.p_num < 100)
// return [...sum, ...filtered]
// } else if (cur === 2) {
//     const filtered = list.filter((data) => data.p_num > 99 && data.p_num < 200)
//     return [...sum, ...filtered]
// } else if (cur === 3) {
//     const filtered = list.filter((data) => data.p_num > 199)
const CustomClanCard = ({data, index}) => {
    const router = useHistory();
    const theme = useTheme();
    const [onError, setOnError] = useState(!data.profile_image_url);


    const getSum = (list) => {
        return list.reduce((sum, cur) => {
            return sum + cur;
        }, 0);
    }


    // <Link to={`/connect/${data.server_id}`}>
    return (
            <CardWrapper onClick={() => router.push(`/connect/${data.server_id}`)}>
                <FavoriteAbsolute>
                    <CustomClanFavoriteButton data={data} noBorder={true}/>
                </FavoriteAbsolute>
                <Gradient/>
                <BackgroundWrapper background={'transparent'}>
                    <AbsoluteBackgroundImage>
                        {onError ?
                            <img
                                src={`${theme.icon.path}/connect/img_connect_card_default.png`}
                                width={344}
                                height={208}
                                alt={''}
                            />
                            :
                            <img
                                src={data.profile_image_url}
                                width={344}
                                height={208}
                                alt={''}
                                onError={(e) => setOnError(true)}
                            />}
                    </AbsoluteBackgroundImage>
                    <BackgroundContentWrapper>
                        <CustomCardTitle>
                            {data.server_name}
                        </CustomCardTitle>
                        <CustomCardInfoBox>
                            <CustomCardPlayerBox>
                                <CustomCardPlayerImgBox>
                                    <img
                                        src={`/images/clan/person.svg`}
                                        width={24}
                                        height={24}
                                        alt={''}
                                    />
                                </CustomCardPlayerImgBox>
                                <CustomCardPlayerCountBox>
                                    {threedigits(data.p_num)}
                                </CustomCardPlayerCountBox>
                            </CustomCardPlayerBox>
                            <CustomCardTagBox>
                                {data.server_type > 0 &&
                                <CustomClanTags isServerType={true} value={data.server_type}/>}
                                {data.tags.slice(0,2).map((item,index) => {
                                    return (
                                        <CustomClanTags value={item} key={index}/>
                                    )
                                })}
                                {/*{data.game_mode.map((data, index) => {*/}
                                {/*    return (*/}
                                {/*        <GameModeTag value={data} key={index}/>*/}
                                {/*    )*/}
                                {/*})}*/}
                                {/*{data.clan_mode.map((data, index) => {*/}
                                {/*    return (*/}
                                {/*        <ClanModeTag value={data} key={index}/>*/}
                                {/*    )*/}
                                {/*})}*/}
                                {/*{data.Age.map((data, index) => {*/}
                                {/*    return (*/}
                                {/*        <AgeTag value={data} key={index}/>*/}
                                {/*    )*/}
                                {/*})}*/}
                            </CustomCardTagBox>

                        </CustomCardInfoBox>
                    </BackgroundContentWrapper>
                </BackgroundWrapper>
            </CardWrapper>
    )
}




export default CustomClanCardTable;